import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Label,
  Row,
} from "reactstrap";
import { APIClient } from "../../helpers/api_helper";
import {
  ADMIN_ACTIVE_INACTIVE_EMPLOYEE,
  IS_LEAD_ENABLE,
  SUPER_ADMIN_BY_PASSS_API,
  SUPER_ADMIN_EMPLOYEE_DATATABLE,
} from "../../helpers/url_helper";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { toCamelCase } from "../../Components/Common/ToCamelCase";
import moment from "moment";
import { HandleErrorMessage } from "../../Components/Common/HandleErrorMessage";
import Toast from "../../Components/Common/Toast";
import { toast, ToastContainer } from "react-toastify";
import UpdateAdmin from "./UpdatedAdmin";
import CommanDataTable from "../../Components/Common/DataTable";
import { Link } from "react-router-dom";
import { CommonLabel } from "../../Components/Common/CommonLabel";
import { CommonSelectInput } from "../../Components/Common/CommonSelectInput";
import { getPricingPlan } from "../../Components/Common/pricingPlan";
import FilterSuperAdmin from "./FilterSuperAdmin";
import { CommanDataTables } from "../../Components/Common/DashboardDataTbale";
const api = new APIClient();

const DashboardCallCrm = () => {
  const [employeeData, setEmployeeTableData] = useState([]);
  const [filteredPlanData, setFilteredPlanData] = useState([]);
  const [modal_grid, setmodal_grid] = useState(false);
  const [orgDetail, setOrgDetails] = useState({});
  // Pagination state
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [query, setQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState("");
  const [orgStatus, setorgStatus] = useState("");
  const [pricingPlan, setPricingPlan] = useState([]);
  const [orgPaidType, setPricingType] = useState(null);

  // State for report view handling
  const [showPlanReport, setShowPlanReport] = useState(false);
  const [planReportType, setPlanReportType] = useState("");
  const [planReportTitle, setPlanReportTitle] = useState("");

  // New states for column filtering
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [activeColumns, setActiveColumns] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [debouncedSearchText, setDebouncedSearchText] = useState("");
  const [filterData, setFilteredData] = useState([]);

  // Define default columns for different views
  const defaultColumns = {
    normal: [
      "srNo",
      "organizationName",
      "organizationId",
      "mobileNumber",
      "email",
      "createdAt",
      "selectedPlan",
      "status",
      "actions",
      "isLeadEnable",
      "salesPerson",
      "employeeCount",
      "verified",
    ],
    active: [
      "srNo",
      "organizationName",
      "organizationId",
      "mobileNumber",
      "email",
      "createdAt",
      "selectedPlan",
      "status",
      "actions",
      "isLeadEnable",
      "salesPerson",
      "daysDiff",
      "daysRemaining",
      "employeeCount",
      "verified",
    ],
    expired: [
      "srNo",
      "organizationName",
      "organizationId",
      "mobileNumber",
      "email",
      "createdAt",
      "selectedPlan",
      "status",
      "actions",
      "isLeadEnable",
      "salesPerson",
      "daysDiff",
      "daysExpired",
      "employeeCount",
      "verified",
    ],
  };

  // Define columns for the data table
  const defineColumns = () => {
    // Base columns that are always present
    const baseColumns = [
      {
        id: "srNo",
        name: <span className="font-weight-bold fs-13">Sr. No</span>,
        selector: (row, index) => index + 1,
        sortable: true,
        width: "90px",
      },
      {
        id: "organizationName",
        name: (
          <span
            className="font-weight-bold fs-13"
            style={{ textAlign: "left", width: "100%" }}
          >
            Organization Name
          </span>
        ),
        selector: (row) => toCamelCase(row?.organizationName) || "-",
        cell: (row) => (
          <div style={{ textAlign: "left", width: "100%" }}>
            <Link
              onClick={(e) => {
                e.preventDefault();
                handleClick(row);
              }}
              style={{
                textTransform: "capitalize",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
              className="text-primary"
              title={row?.organizationName}
            >
              {row?.organizationName || "-"}
            </Link>
          </div>
        ),
        sortable: true,
        minWidth: "165px",
        grow: 1,
      },
      {
        id: "organizationId",
        name: (
          <span
            className="font-weight-bold fs-13"
            style={{ textAlign: "left", width: "100%" }}
          >
            Organization ID
          </span>
        ),
        selector: (row) => row.organizationId || "-",
        cell: (row) => (
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "100%",
            }}
            title={row.organizationId}
          >
            {row.organizationId || "-"}
          </div>
        ),
        sortable: true,
        minWidth: "145px",
        grow: 0,
      },
      {
        id: "mobileNumber",
        name: (
          <span
            className="font-weight-bold fs-13"
            style={{ textAlign: "left", width: "100%" }}
          >
            Mobile
          </span>
        ),
        selector: (row) => row.mobileNumber || "-",
        cell: (row) => (
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "100%",
              fontWeight: 500,
            }}
            title={row.mobileNumber}
          >
            {row.mobileNumber || "-"}
          </div>
        ),
        sortable: true,
        minWidth: "130px",
        grow: 0,
      },
      {
        id: "email",
        name: (
          <span
            className="font-weight-bold fs-13"
            style={{ textAlign: "left", width: "100%" }}
          >
            Email
          </span>
        ),
        selector: (row) => row.email || "-",
        cell: (row) => (
          <div
            style={{
              textAlign: "left",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              wordBreak: "break-word",
            }}
            title={row.email}
          >
            {row.email || "-"}
          </div>
        ),
        sortable: true,
        minWidth: "170px",
        grow: 1,
      },
      {
        id: "createdAt",
        name: (
          <span
            className="font-weight-bold fs-13"
            style={{ textAlign: "left", width: "100%" }}
          >
            Creation Date
          </span>
        ),
        selector: (row) =>
          row.createdAt ? new Date(row.createdAt).getTime() : 0,
        cell: (row) => {
          if (!row.createdAt) return "-";

          const date = moment(row.createdAt).format("DD MMM YYYY");
          const time = moment(row.createdAt).format("hh:mm A");

          return (
            <div style={{ lineHeight: "1.3" }}>
              <div>{date}</div>
              <div style={{ fontSize: "12px", color: "#6c757d" }}>{time}</div>
            </div>
          );
        },
        sortable: true,
        minWidth: "150px",
        grow: 0,
      },
      {
        id: "selectedPlan",
        name: <span className="font-weight-bold fs-13">Plan</span>,
        selector: (row) => row.selectedPlan,
        cell: (row) => (
          <span className="sn-managment-team-scroll-tble">
            {row.selectedPlan || "-"}
          </span>
        ),
        sortable: true,
        width: "100px",
      },
      {
        id: "salesPerson",
        name: <span className="font-weight-bold fs-13">Sales Person</span>,
        selector: (row) => row.salesPersonName || "",
        sortable: true,
        sortFunction: (a, b) => {
          const nameA = (a.salesPersonName || "").toLowerCase();
          const nameB = (b.salesPersonName || "").toLowerCase();
          return nameA.localeCompare(nameB);
        },
        cell: (row) => (
          <span className="sn-managment-team-scroll-tble">
            {row.salesPersonName ? row.salesPersonName : "-"}
          </span>
        ),
        width: "150px",
      },
      {
        id: "subscriptionStartDate",
        name: <span>Subscription Start Date</span>,
        selector: (row) =>
          moment(row.subscriptionStartDate).format("DD MMM YYYY") || "-",
        cell: (row) =>
          (
            <span className="sn-managment-team-scroll-tble">
              {row.subscriptionStartDate
                ? moment(row.subscriptionStartDate).format("DD MMM YYYY")
                : "-"}
            </span>
          ) || "-",
        sortable: true,
        width: "120px",
      },
      {
        id: "subscriptionEndDate",
        name: <span>Subscription End Date</span>,
        selector: (row) =>
          moment(row.subscriptionEndDate).format("DD MMM YYYY") || "-",
        cell: (row) =>
          (
            <span className="sn-managment-team-scroll-tble">
              {row.subscriptionEndDate
                ? moment(row.subscriptionEndDate).format("DD MMM YYYY")
                : "-"}
            </span>
          ) || "-",
        sortable: true,
        width: "120px",
      },
      {
        id: "subscriptionStatus",
        name: <span>Subscription Status</span>,
        selector: (row) => {
          const endDate = moment(row.subscriptionEndDate);
          const today = moment();
          return endDate.isBefore(today) ? "Expired" : "Active";
        },
        cell: (row) => {
          const endDate = moment(row.subscriptionEndDate);
          const today = moment();
          const isExpired = endDate.isBefore(today);

          return (
            <span className={`badge ${isExpired ? "bg-danger" : "bg-success"}`}>
              {isExpired ? "Expired" : "Active"}
            </span>
          );
        },
        sortable: true,
        width: "120px",
      },
      {
        id: "verified",
        name: <span className="font-weight-bold fs-13">Verified</span>,
        selector: (row) => row.verified,
        cell: (row) => (
          <span className="sn-managment-team-scroll-tble">
            {`${row.verified}`}
          </span>
        ),
        sortable: true,
      },
      {
        id: "employeeCount",
        name: <span className="font-weight-bold fs-13">Employee Count</span>,
        selector: (row) => row.employeeCount,
        cell: (row) => (
          <span className="sn-managment-team-scroll-tble">
            {`${row.employeeCount}`}
          </span>
        ),
        sortable: true,
      },
      {
        id: "isLeadEnable",
        name: <span className="font-weight-bold fs-13">Lead Status</span>,
        selector: (row) => row.isLeadEnable,
        cell: (row) => (
          <div className="form-check form-switch form-switch-success mb-3 ms-3 mt-3">
            <Input
              checked={row.isLeadEnable ? true : false}
              className="form-check-input"
              type="checkbox"
              role="switch"
              id={`LeadSwitch_${row._id}`}
              onChange={() => handleLeadStatusChange(row)}
            />
            <Label className="form-check-label" for={`LeadSwitch_${row._id}`}>
              {row.isLeadEnable ? "Enabled" : "Disabled"}
            </Label>
          </div>
        ),
        sortable: true,
        width: "140px",
      },
      {
        id: "status",
        name: <span className="font-weight-bold fs-13">Status</span>,
        selector: (row) => row.status,
        cell: (row) => (
          <div className="form-check form-switch form-switch-success mb-3 ms-3 mt-3">
            <Input
              checked={row.status === "Active" ? true : false}
              className="form-check-input"
              type="checkbox"
              role="switch"
              id={`SwitchCheck_${row._id}`}
              onChange={() => handleCheckboxChange(row)}
            />
            <Label className="form-check-label" for={`SwitchCheck_${row._id}`}>
              {row.status === "Active" ? "Active" : "Inactive"}
            </Label>
          </div>
        ),
        sortable: true,
        width: "140px",
      },
      {
        id: "actions",
        name: <span className="font-weight-bold fs-13">Action</span>,
        cell: (row) => (
          <>
            <div className="hstack gap-2 sn-button-eye-edit-user">
              <button
                className="btn btn-sm btn-soft-success edit-list"
                onClick={() => showModal(row)}
              >
                <i className="ri-pencil-fill align-bottom" />
              </button>
            </div>
          </>
        ),
      },
    ];

    // Add days remaining column (for active plan reports)
    const daysRemainingColumn = {
      id: "daysRemaining",
      name: <span>Days Remaining</span>,
      selector: (row) => {
        const today = moment();
        const endDate = moment(row.subscriptionEndDate);
        return endDate.diff(today, "days");
      },
      cell: (row) => {
        const today = moment();
        const endDate = moment(row.subscriptionEndDate);
        const daysDiff = endDate.diff(today, "days");

        return (
          <div className="text-primary">
            {row.selectedPlan === "free" ? "-" : `${daysDiff} days remaining`}
          </div>
        );
      },
      sortable: true,
      width: "150px",
    };

    // Add days expired column (for expired plan reports)
    const daysExpiredColumn = {
      id: "daysExpired",
      name: <span>Days Expired</span>,
      selector: (row) => {
        const today = moment();
        const endDate = moment(row.subscriptionEndDate);
        return Math.abs(endDate.diff(today, "days"));
      },
      cell: (row) => {
        const today = moment();
        const endDate = moment(row.subscriptionEndDate);
        const daysDiff = Math.abs(endDate.diff(today, "days"));

        return <div className="text-danger">Expired ({daysDiff} days)</div>;
      },
      sortable: true,
      width: "150px",
    };

    // Add specific columns based on report type
    let allColumns = [...baseColumns];

    if (showPlanReport) {
      if (planReportType === "active") {
        // Add days remaining column for active plans
        allColumns.push(daysRemainingColumn);
      } else if (planReportType === "expired") {
        // Add days expired column for expired plans
        allColumns.push(daysExpiredColumn);
      }
    }

    return allColumns;
  };

  // Initialize columns
  const allColumns = defineColumns();

  // Initialize activeColumns and selectedOptions on component mount
  useEffect(() => {
    const columns = defineColumns();

    // Determine which default columns to use based on report type
    let defaultSelected;
    if (showPlanReport) {
      if (planReportType === "active") {
        defaultSelected = defaultColumns.active;
      } else if (planReportType === "expired") {
        defaultSelected = defaultColumns.expired;
      } else {
        defaultSelected = defaultColumns.normal;
      }
    } else {
      defaultSelected = defaultColumns.normal;
    }

    // Filter columns to only include those in the default columns array
    const filteredColumns = columns.filter((col) =>
      defaultSelected.includes(col.id),
    );
    setActiveColumns(filteredColumns);
    setSelectedOptions(defaultSelected);
  }, [showPlanReport, planReportType]);

  // Handle the click event when the Super Admin is being logged in
  let isReloading = false; // Flag to track page reload state

  const handleClick = async (data) => {
    try {
      const response = await api.create(`${SUPER_ADMIN_BY_PASSS_API}`, data);

      if (response?.message === "success") {
        const organizationToken = response?.data?.token;
        const newTab = window.open("/dashboard", "_blank");

        if (newTab) {
          localStorage.setItem("authUser", JSON.stringify(organizationToken));
          localStorage.setItem("logintype", JSON.stringify("organization"));
          localStorage.removeItem("SuperAdminlogintype");
          newTab.focus();
        } else {
          console.warn(
            "Failed to open new tab. Please check your browser's pop-up settings.",
          );
          localStorage.setItem(
            "SuperAdminlogintype",
            JSON.stringify("SuperAdmin"),
          );
          localStorage.removeItem("logintype");
        }
      } else {
        console.error("response", response);
        Toast(response.message, "error");
      }
    } catch (error) {
      console.error("Error", error);
      throw error;
    }
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (!isReloading) {
        // Prevent changes to localStorage on reload
        event.preventDefault();
      }
      isReloading = false; // Reset the reloading flag after event
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    const path = window.location.pathname;

    if (path === "/admin-dashboard") {
      localStorage.setItem("SuperAdminlogintype", JSON.stringify("SuperAdmin"));
      localStorage.removeItem("logintype");
    } else if (path === "/dashboard") {
      localStorage.setItem("logintype", JSON.stringify("organization"));
      localStorage.removeItem("SuperAdminlogintype");
    }
  }, [window.location.pathname]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      isReloading = true;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      isReloading = false;
    };
  }, []);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (isReloading) return;

      if (document.visibilityState === "visible") {
        localStorage.setItem(
          "SuperAdminlogintype",
          JSON.stringify("SuperAdmin"),
        );
        localStorage.removeItem("logintype");
      } else {
        localStorage.setItem("logintype", JSON.stringify("organization"));
        localStorage.removeItem("SuperAdminlogintype");
      }
    };

    window.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  const handleLeadStatusChange = async (row) => {
    const newLeadStatus = !row.isLeadEnable;
    try {
      const response = await api.patch(`${IS_LEAD_ENABLE}`, {
        isLeadEnable: newLeadStatus,
        organizationId: row._id,
      });
      Toast(response?.message, "success");
      setEmployeeTableData((prevRows) =>
        prevRows.map((item) =>
          item._id === row._id
            ? { ...item, isLeadEnable: newLeadStatus }
            : item,
        ),
      );

      // Update filtered data if we're in plan report view
      if (showPlanReport) {
        setFilteredPlanData((prevRows) =>
          prevRows.map((item) =>
            item._id === row._id
              ? { ...item, isLeadEnable: newLeadStatus }
              : item,
          ),
        );
      }
    } catch (error) {
      HandleErrorMessage(error);
    }
  };

  const showModal = (row) => {
    setmodal_grid(true);
    setOrgDetails({
      id: row._id,
      orgid: row.organizationId,
      orgname: row.organizationName,
      email: row.email,
      city: row.city,
      country: row.country,
      address: row.address,
      mobileNumber: row.mobileNumber,
      state: row.state,
      orgStrength: row.organizationStrength,
      industryType: row.industryType,
      pincode: row.pincode,
      creation: row.createdAt,
      salesPersonId: row.salesPersonId,
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      if (debouncedQuery.length >= 3 || debouncedQuery.length === 0) {
        await EmployeeDataApi(currentPage, perPage, debouncedQuery);
      }
    };

    fetchData();
    getPricingPlan(setPricingPlan);
  }, [debouncedQuery]);

  // Search field handler
  const handleSearch = (e) => {
    setQuery(e.target.value);
  };

  // Debounce search query
  useEffect(() => {
    const handler = setTimeout(() => {
      if (query.length >= 3) {
        setDebouncedSearchText(query);
      } else {
        setDebouncedSearchText("");
      }
    }, 300);

    return () => {
      clearTimeout(handler);
    };
  }, [query]);

  useEffect(() => {
    // If we're showing a plan report, filter accordingly
    if (showPlanReport) {
      let dataToFilter = employeeData || [];
      if (planReportType === "active") {
        // Show only active subscription plans
        const filtered = dataToFilter.filter((item) => {
          const endDate = moment(item.subscriptionEndDate);
          const today = moment();
          return !endDate.isBefore(today) && item.verified === true;
        });
        setFilteredPlanData(filtered);
      } else if (planReportType === "expired") {
        // Show only expired subscription plans
        const filtered = dataToFilter.filter((item) => {
          const endDate = moment(item.subscriptionEndDate);
          const today = moment();
          return endDate.isBefore(today) && item.verified === true;
        });
        setFilteredPlanData(filtered);
      }
    } else {
      // Regular search filtering
      const filtered = (employeeData || []).filter((item) =>
        Object.values(item).some((value) =>
          value
            ?.toString()
            ?.toLowerCase()
            ?.includes(debouncedSearchText.toLowerCase()),
        ),
      );
      setFilteredData(filtered);
    }

    if (debouncedSearchText) setCurrentPage(1);
  }, [employeeData, debouncedSearchText, showPlanReport, planReportType]);

  const handleSelect = async (e) => {
    const result = e.target.value;
    setorgStatus(result);
    setShowPlanReport(false); // Reset plan report view
    await EmployeeDataApi(
      currentPage,
      perPage,
      debouncedQuery,
      result,
      orgPaidType,
    );
  };

  const handlePricingSelect = async (e) => {
    const result = e.target.value;
    setPricingType(result);
    setShowPlanReport(false); // Reset plan report view
    await EmployeeDataApi(
      currentPage,
      perPage,
      debouncedQuery,
      orgStatus,
      result,
    );
  };

  // Handling Active Plan Report view
  const handleActivePlanReport = () => {
    setPlanReportType("active");
    setPlanReportTitle("Active Plan Report");
    setShowPlanReport(true);
    setCurrentPage(1);
  };

  // Handling Expired Plan Report view
  const handleExpiredPlanReport = () => {
    setPlanReportType("expired");
    setPlanReportTitle("Expired Plan Report");
    setShowPlanReport(true);
    setCurrentPage(1);
  };

  // Reset to default view (back button handler)
  const handleResetView = () => {
    setShowPlanReport(false);
    setPlanReportType("");
    setPlanReportTitle("");
    // Reset to default filtering if needed
    EmployeeDataApi(1, perPage, debouncedQuery, orgStatus, orgPaidType);
  };

  const EmployeeDataApi = useCallback(
    async (page, size = perPage, searchTerm = "", status = "", type = "") => {
      try {
        const response = await api.create(`${SUPER_ADMIN_EMPLOYEE_DATATABLE}`, {
          status,
          type,
        });
        if (response && response.success === true) {
          const apiResponse = response.data;

          const sortedData = apiResponse?.organization.sort(
            (a, b) =>
              moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf(),
          );

          setEmployeeTableData(sortedData);
          setTotalRows(apiResponse?.totalCount);

          // If we're in a plan report view, update filtered data
          if (showPlanReport) {
            if (planReportType === "active") {
              const filtered = sortedData.filter((item) => {
                const endDate = moment(item.subscriptionEndDate);
                const today = moment();
                return !endDate.isBefore(today);
              });
              setFilteredPlanData(filtered);
            } else if (planReportType === "expired") {
              const filtered = sortedData.filter((item) => {
                const endDate = moment(item.subscriptionEndDate);
                const today = moment();
                return endDate.isBefore(today);
              });
              setFilteredPlanData(filtered);
            }
          }
        }
      } catch (error) {
        console.log("Error fetching data:", error);
      }
    },
    [orgStatus, showPlanReport, planReportType],
  );

  const handleCheckboxChange = async (row) => {
    const newStatus = row.status === "Active" ? "Inactive" : "Active";
    try {
      const response = await api.patch(`${ADMIN_ACTIVE_INACTIVE_EMPLOYEE}`, {
        status: newStatus,
        organization_id: row._id,
      });
      Toast(response?.message, "success");
      setEmployeeTableData((prevRows) =>
        prevRows.map((item) =>
          item._id === row._id ? { ...item, status: newStatus } : item,
        ),
      );

      // Update filtered data if we're in plan report view
      if (showPlanReport) {
        setFilteredPlanData((prevRows) =>
          prevRows.map((item) =>
            item._id === row._id ? { ...item, status: newStatus } : item,
          ),
        );
      }
    } catch (error) {
      HandleErrorMessage(error);
    }
  };

  // Pagination handler
  const handlePageChange = async (page) => {
    setCurrentPage(page);
    if (!showPlanReport) {
      await EmployeeDataApi(page, perPage, "", orgStatus, orgPaidType);
    }
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
    if (!showPlanReport) {
      await EmployeeDataApi(page, newPerPage, "", orgStatus, orgPaidType);
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="page-content sn-team-managment-main-page">
        <Container fluid>
          <BreadCrumb title="DASHBOARD" pageTitle="Tables" />
          <Row>
            <Col lg={12}>
              <Card className="h-100">
                <CardHeader className="align-items-center d-flex">
                  <h4 className="card-title mb-0 flex-grow-1">
                    {showPlanReport
                      ? planReportTitle
                      : "Organization Management"}
                  </h4>
                  {showPlanReport && (
                    <button
                      onClick={handleResetView}
                      className="btn btn-sm border border-rounded shadow backbtn-main mb-4"
                    >
                      <i className="ri-arrow-left-line me-1"></i> Back
                    </button>
                  )}
                </CardHeader>
                <CardBody>
                  {!showPlanReport && (
                    <Row>
                      <Col sm={3}>
                        <CommonLabel htmlFor="orgStatus">
                          Select Status
                        </CommonLabel>
                        <CommonSelectInput
                          name="orgStatus"
                          label="Select Status"
                          isRequired={false}
                          options={[
                            { value: "", label: "All" },
                            { value: "Active", label: "Active" },
                            { value: "Inactive", label: "Inactive" },
                          ]}
                          tooltipId="my-tooltip-5"
                          onChange={handleSelect}
                        />
                      </Col>
                      <Col sm={3}>
                        <CommonLabel htmlFor="orgPaidType">
                          Select Paid Type
                        </CommonLabel>
                        <CommonSelectInput
                          name="orgPaidType"
                          label="Select Paid Type"
                          isRequired={false}
                          options={pricingPlan}
                          tooltipId="my-tooltip-5"
                          onChange={handlePricingSelect}
                        />
                      </Col>

                      <Col sm={6}>
                        <div className="d-flex justify-content-end mt-4 gap-4">
                          <span
                            onClick={handleActivePlanReport}
                            className="cursor-pointer text-danger"
                            style={{ cursor: "pointer" }}
                          >
                            Active Plan Report
                          </span>
                          <span
                            onClick={handleExpiredPlanReport}
                            className="cursor-pointer text-danger"
                            style={{ cursor: "pointer" }}
                          >
                            Expired Plan Report
                          </span>
                        </div>
                      </Col>
                    </Row>
                  )}

                  <Row className="mt-3">
                    <div className="d-flex">
                      {(showPlanReport ? filteredPlanData : employeeData) &&
                        (showPlanReport ? filteredPlanData : employeeData)
                          .length > 0 && (
                          <FilterSuperAdmin
                            isDropdownOpen={isDropdownOpen}
                            setIsDropdownOpen={setIsDropdownOpen}
                            setActiveColumns={setActiveColumns}
                            allColumns={allColumns}
                            selectedOptions={selectedOptions}
                            setSelectedOptions={setSelectedOptions}
                            defaultColumns={
                              showPlanReport
                                ? planReportType === "active"
                                  ? defaultColumns.active
                                  : planReportType === "expired"
                                    ? defaultColumns.expired
                                    : defaultColumns.normal
                                : defaultColumns.normal
                            }
                          />
                        )}
                    </div>
                  </Row>

                  <Row>
                    <CommanDataTables
                      setCurrentPage={setCurrentPage}
                      perPage={perPage}
                      column={activeColumns}
                      tableData={showPlanReport ? filteredPlanData : filterData}
                      handleSearch={handleSearch}
                      searchText={query}
                      handlePerRowsChange={handlePerRowsChange}
                      totalRows={
                        showPlanReport ? filteredPlanData.length : totalRows
                      }
                      currentPage={currentPage}
                      handlePageChange={handlePageChange}
                      noData="There are no records to display"
                    />
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <UpdateAdmin
          modal_grid={modal_grid}
          EmployeeDataApi={EmployeeDataApi}
          setmodal_grid={setmodal_grid}
          orgDetail={orgDetail}
        />
      </div>
    </React.Fragment>
  );
};

export default DashboardCallCrm;
